<template>
  <div class="secondary_small gap-1" @click="$emit('remove')">
    <ThemeImage
        class="size-4"
        :icon="imageNames.REMOVE_LIST_GREY"
        alt="dropdown_icon"
    />
    Remove from list
  </div>
</template>

<script setup>
import {imageNames} from "@/src/constants/imageConstants.js";

defineEmits(['remove']);
</script>
